export default "__VITE_ASSET__CeZgZyFp__"